import Login from 'client/js/login';
import PasswordReset from 'client/js/password_reset';
import PropTypes from 'prop-types';
import { BrowserRouter, Redirect, Route, StaticRouter, Switch } from 'react-router-dom';
import Signup from 'client/js/signup';

const routes = {
  login: '/login',
  signup: '/register',
  password_reset: '/lostpassword'
};

class AuthFlow extends React.Component {
  renderRouter(children) {
    if (typeof window === 'undefined')
      return <StaticRouter location={routes[this.props.initial_page]}>{children}</StaticRouter>;

    return <BrowserRouter>{children}</BrowserRouter>;
  }

  render() {
    return this.renderRouter(
      <Switch>
        <Route exact path={routes.signup} render={() => <Signup {...this.props.signup} />} />
        <Route exact path={routes.password_reset} render={() => <PasswordReset {...this.props.password_reset} />} />
        <Route exact path={routes.login} render={() => <Login {...this.props.login} />} />
        <Route render={() => {
          if (this.props.initial_page === 'signup')
            return <Signup {...this.props.signup} />;

          if (this.props.initial_page === 'password_reset')
            return <PasswordReset {...this.props.password_reset} />;

          return <Redirect to={routes.login} />;
        }} />
      </Switch>
    );
  }
}

AuthFlow.defaultProps = {
  login: {},
  password_reset: {},
  signup: {}
};

AuthFlow.propTypes = {
  initial_page: PropTypes.oneOf(['login', 'signup', 'password_reset']).isRequired,
  login: PropTypes.object,
  password_reset: PropTypes.object,
  signup: PropTypes.object
};

export default AuthFlow;
